import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "key-country-indicator export-page" }
const _hoisted_2 = {
  key: 0,
  class: "container-page big"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_TableWithOuterFilter = _resolveComponent("TableWithOuterFilter")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      dense: "",
      title: "Ключевой показатель страны"
    }, {
      button: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_ButtonComponent, {
          mod: "gradient-bg",
          onClick: _ctx.redirectToAddPage
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("Создать", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])), [
          [_directive_permission, _ctx.permissions.create]
        ])
      ]),
      _: 1
    }),
    (_ctx.isAccessAllowed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_TableWithOuterFilter, {
            tableConfig: _ctx.tableConfig,
            filtersConfig: _ctx.getFiltersConfig,
            tableClass: "key-country-indicator__table",
            onSearchFilter: _ctx.searchFilter
          }, null, 8, ["tableConfig", "filtersConfig", "onSearchFilter"])
        ]))
      : _createCommentVNode("", true)
  ]))
}